import axios from 'axios';

export const InsertContactIngDesk = (url,displayname,name,email,cpf,rg,codigoexterno,endereco,numero,district,numberscontact,token_ingdesk,empresa) => {
  return (dispatch) => {
    let structNumbers = [];
    for(let struct of numberscontact){
        structNumbers.push({telephone: struct.number})
    }
    
    let jsonSendingIngDesk = {
        "numbers": structNumbers,
        "name": name, 
        "displayname": displayname,
        "cpf": cpf, 
        "rg": rg, 
        "address": endereco, 
        "number": numero,
        "email": email,
        "district": district,
        "externcode": codigoexterno,
        "empresa": empresa !== "" ? empresa[0].label:""
    }

    const config = {
        headers: {
          'x-access-token': token_ingdesk,
          'Content-Type': 'application/json'
        }
      }

    axios.post(`${url}/create-contact`, jsonSendingIngDesk, config)
      .then(response => {
        console.log("CADASTRADO COM SUCESSO NO INGDESK")
      })
      .catch(error => {
        console.log("ERRO AO CADASTRAR NO INGDESK")
      });
    }
  }

  export const ConnectionsAPI = (imsdn,db,sip,mensagem) => ({ type: 'CONNECTIONAPI', imsdn: imsdn, db: db, sip: sip, mensagem: mensagem })